import React, {Component} from 'react';
import axios from 'axios';

import {Page, Preload} from '../components';
import {renderMoney} from '../utils';

import '../css/page/LectureRewardListPage.css';


class LectureRewardListPage extends Component {
    constructor() {
        super();
        this.state = {
            initialized: false,
            data: {}
        }
    }

    componentDidMount() {
        const {lecture_id} = this.props.params;
        axios.get(`/api/datacenter/lecture_data/${lecture_id}/reward/lecturer`).then(res => {
            if (res.data.code === 0) {
                this.setState({initialized: true, data: res.data.data});
            }
        })
    }

    render() {
        const {initialized, data} = this.state;

        if (!initialized) {
            return <Preload/>;
        }

        return (
            <Page className="lecture-reward-list-page">
                <div className="wk-inner-page">
                    <div className="page-title">打赏收入明细（{data.reward_user_count}人打赏 / 共{renderMoney(data.total_rewards)}元）</div>
                    {data.rewards.map((item, index) => (
                        <div className="weui-flex invite-item border-line" key={index}>
                            <div className="invite-left weui-flex__item flex_2">
                                <div className="portrait">
                                    <img src={item.headimg} alt=""/>
                                </div>
                            </div>

                            <div className="invite-middle weui-flex__item flex_8">{item.nickname}</div>

                            <div className="invite-right weui-flex__item flex_2">{"￥" + renderMoney(item.reward)}</div>
                        </div>
                    ))}
                </div>
            </Page>
        )
    }
}

export default LectureRewardListPage;



// WEBPACK FOOTER //
// ./src/pages/LectureRewardListPage.js